export default () => ({
  el: undefined,
  gridId: undefined,
  deleteTriggerId: undefined,
  endpoint: undefined,
  nextPage: undefined,
  init() {
    mrp.log(`RxDataGridRows init`);
    this.el = this.$el;
    this.gridId = this.el.getAttribute("data-grid-id");
    this.deleteTriggerId = this.el.getAttribute("data-delete-trigger-id");
    this.endpoint = this.el.getAttribute("data-endpoint");
    this.nextPage = this.el.getAttribute("data-next-page");
    sessionStorage.setItem(
      `${this.gridId}-context`,
      `context=${encodeURIComponent(
        this.el.getAttribute("data-context") ?? ""
      )}`
    );
    const currentSelectedId = sessionStorage.getItem(`${this.gridId}-selected`);
    const selectedRow = this.el.querySelector(
      `[data-key-property='${currentSelectedId}']`
    );
    selectedRow?.classList.add("selected");
    const lastRow = this.el.querySelector("[data-last-row='true']");
    if (lastRow) {
      const filter = sessionStorage.getItem(`${this.gridId}-filter`) ?? "";
      const sort = sessionStorage.getItem(`${this.gridId}-sort`) ?? "";
      const context = sessionStorage.getItem(`${this.gridId}-context`) ?? "";
      const route = `${this.endpoint}/${this.nextPage}?${sort}&${filter}&${context}`;
      lastRow.setAttribute("hx-get", route);
      htmx.process(lastRow);
    }
  },
  click(evt) {
    sessionStorage.removeItem(`${this.gridId}-selected`);
    this.el.childNodes.forEach((ele) => {
      ele.classList.remove("selected");
    });
    const actionEndpoint = evt.currentTarget.getAttribute(
      "data-action-endpoint"
    );
    const navId = evt.currentTarget.getAttribute("data-nav-id");
    const keyProperty = evt.currentTarget.getAttribute("data-key-property");
    if (keyProperty?.trim() !== "") {
      evt.currentTarget.parentElement.parentElement.classList.add("selected");
    }
    sessionStorage.setItem(`${this.gridId}-selected`, keyProperty ?? navId);
    if (!actionEndpoint) {
      return;
    }
    const route = `${actionEndpoint}/${keyProperty}`;
    if (!navId) {
      htmx.ajax("GET", route, {
        target: "none",
        swap: "none",
      });
    }
  },
  deleteSelectionChanged() {
    const trigger = document.getElementById(this.deleteTriggerId);
    let records = this.el.querySelectorAll(
      `[name='${this.gridId}-delete-record']`
    );
    trigger.setAttribute("disabled", "");
    for (let i = 0; i < records.length; i++) {
      if (records[i].checked) {
        trigger.removeAttribute("disabled");
        return;
      }
    }
  },
});
